import { ApplicationWso2FormData } from '../domain/ApplicationWso2FormData'
import { ApplicationWso2EditRequest } from './update/dto/ApplicationWso2EditRequest'

export const applicationWso2EditRequestFromFormData = (input: ApplicationWso2FormData): ApplicationWso2EditRequest => ({
	applicationName: input.applicationName,
	corporateGroupId: input.corporateGroup.value,
	active: input.active,
})
